/** Successful appeal generate payload when the case is appeal-eligible. */
export interface AppealGenerateEligibleDetails {
  appeal_eligible?: true;
  appeal_viable?: boolean;
  appeal_probability?: number;
  probability_band?: string;
  recovery_priority?: string;
  recovery_classification?: string;
  root_cause?: string;
  recovery_opportunities?: string;
  strategy?: string;
  required_documents?: string[];
  appeal_letter?: string;
  appeal_letter_path?: string;
  appeal_letter_url?: string;
  full_text?: string;
  notes?: string | null;
  epa_appeal_available?: boolean;
}

/** Appeal generate payload when the case is not appeal-eligible. */
export interface AppealGenerateIneligibleDetails {
  appeal_eligible: false;
  classification?: string;
  reason?: string;
}

export type AppealGenerateDetails =
  | AppealGenerateEligibleDetails
  | AppealGenerateIneligibleDetails;

/**
 * Returns whether generate-appeal details represent an eligible case.
 *
 * @param details - `details` object from the generate appeal API
 * @returns True when the backend marked the case appeal-eligible
 */
export const isAppealGenerateEligible = (
  details: AppealGenerateDetails | undefined,
): details is AppealGenerateEligibleDetails =>
  details != null && details.appeal_eligible !== false;
